(function () {
  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function init(root) {
    if (!root) return;
    const grid = root.querySelector("[data-gallery-grid]");
    const prev = root.querySelector("[data-prev]");
    const next = root.querySelector("[data-next]");
    const thumb = root.querySelector("[data-scrollbar-thumb]");
    if (!grid || !prev || !next || !thumb) return;

    const getGap = () => {
      const st = getComputedStyle(grid);
      return parseFloat(st.columnGap || st.gap || 0);
    };
    const getTile = () => grid.querySelector(".gallery-item");
    const tileWidth = () => {
      const el = getTile();
      if (!el) return 0;
      return el.getBoundingClientRect().width + getGap();
    };

    const canScrollLeft = () => grid.scrollLeft > 2;
    const canScrollRight = () =>
      grid.scrollLeft + grid.clientWidth < grid.scrollWidth - 2;

    const updateArrows = () => {
      prev.disabled = !canScrollLeft();
      next.disabled = !canScrollRight();
    };

    // Custom scrollbar: size + position
    const updateScrollbar = () => {
      const total = grid.scrollWidth;
      const visible = grid.clientWidth;
      const scrollLeft = grid.scrollLeft;

      if (total <= visible) {
        thumb.style.width = "100%";
        thumb.style.left = "0";
        return;
      }

      const scrollable = total - visible;
      const widthPercent = (visible / total) * 100;
      const leftPercent = (scrollLeft / scrollable) * (100 - widthPercent);

      thumb.style.width = widthPercent.toFixed(3) + "%";
      thumb.style.left = leftPercent.toFixed(3) + "%";
    };

    const scrollByTiles = (n) =>
      grid.scrollBy({ left: n * tileWidth(), behavior: "smooth" });

    prev.addEventListener("click", () => scrollByTiles(-1));
    next.addEventListener("click", () => scrollByTiles(1));

    grid.addEventListener(
      "scroll",
      () => {
        updateArrows();
        updateScrollbar();
      },
      { passive: true }
    );

    const onResize = () => {
      updateArrows();
      updateScrollbar();
    };
    window.addEventListener("resize", onResize);

    // Init
    updateArrows();
    updateScrollbar();

    // Cleanup for Theme Editor hot reload
    root._galleryDestroy = () => window.removeEventListener("resize", onResize);
  }

  // Init on page load
  document.querySelectorAll("[data-gallery]").forEach(init);

  // Theme Editor support
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", (e) => init(e.target));
    document.addEventListener("shopify:section:unload", (e) => {
      if (e.target && e.target._galleryDestroy) e.target._galleryDestroy();
    });
    document.addEventListener("shopify:section:select", (e) => init(e.target));
  }
})();
